import React, { useState } from 'react';
import { ACC, MUT } from '../../lib/styles';
import { applyTabOrder } from '../../lib/tabOrder';
import ProfileSettings from './ProfileSettings';
import CompanySettings from './CompanySettings';
import AdminPanel from './AdminPanel';
import StorageSettings from './StorageSettings';
import TabOrderSettings from './TabOrderSettings';
import RecentlyDeletedSettings from './RecentlyDeletedSettings';

const ADMIN_EMAILS = [import.meta.env.VITE_ADMIN_EMAIL, 'nathan.gentil.ai@gmail.com', 'nathan.gentil@gmail.com'].filter(Boolean);

function SettingsPage({profile,setProfile,session,company,setCompany,onSignOut,machines,setMachines,clients,setClients,vehicles,equipment,tools,initialTab}){
  const isAdmin = ADMIN_EMAILS.includes(session?.user?.email);
  const [tab,setTab]=useState(initialTab||"profile");
  // Billing tab removed for now (no paid plan to manage — see gates.js) and
  // Users folded into Company / Org (CompanySettings.jsx renders UsersTab
  // inline) rather than being a separate top-level tab.
  const baseTabs=[
    {id:"profile",  label:"Profile"},
    {id:"company",  label:"Company / Org"},
    {id:"storage",  label:"Billing & Storage"},
    {id:"tabs",     label:"Tabs"},
    {id:"trash",    label:"Recently Deleted"},
  ];
  const tabs = applyTabOrder(baseTabs, profile?.tab_order?.settings).concat(
    isAdmin ? [{id:"admin",label:"Admin"}] : []
  );
  return(
    <div style={{padding:16,flex:1,maxWidth:560,margin:"0 auto",width:"100%"}}>
      <div style={{display:"flex",borderBottom:"1px solid #252525",marginBottom:20,overflowX:"auto",WebkitOverflowScrolling:"touch",scrollbarWidth:"none",msOverflowStyle:"none"}}>
        {tabs.map(({id,label})=>(
          <button key={id} className="tab-btn" onClick={()=>setTab(id)} style={{background:"none",border:"none",borderBottom:tab===id?"2px solid "+ACC:"2px solid transparent",color:tab===id?ACC:MUT,padding:"10px 14px",fontSize:9,fontWeight:700,letterSpacing:"0.06em",textTransform:"uppercase",cursor:"pointer",fontFamily:"'IBM Plex Mono',monospace",transition:"color 0.12s",whiteSpace:"nowrap",flexShrink:0}}>{label}</button>
        ))}
      </div>
      {tab==="profile"&&<ProfileSettings profile={profile} setProfile={setProfile} session={session} onSignOut={onSignOut} isGuest={!!session?.user?.is_anonymous} machines={machines}/>}
      {tab==="company"&&<CompanySettings profile={profile} setProfile={setProfile} company={company} setCompany={setCompany} session={session} machines={machines} vehicles={vehicles} equipment={equipment} tools={tools}/>}
      {tab==="storage"&&<StorageSettings profile={profile} setProfile={setProfile} company={company} setCompany={setCompany}/>}
      {tab==="tabs"&&<TabOrderSettings profile={profile} setProfile={setProfile}/>}
      {tab==="trash"&&<RecentlyDeletedSettings machines={machines} setMachines={setMachines} clients={clients} setClients={setClients}/>}
      {tab==="admin"&&isAdmin&&<AdminPanel/>}
    </div>
  );
}
export default SettingsPage;
